import React from "react";
import "../../../Styles/components/button.scss";

export default function AppButton({
  children,
  className = "",
  disabled = false,
  loading = false,
  type = "button",
  variant = "primary",
  ...props
}) {
  return (
    <button
      type={type}
      className={[
        "app-button",
        `app-button--${variant}`,
        loading ? "is-loading" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <span className="spinner-border spinner-border-sm" /> : null}
      <span>{children}</span>
    </button>
  );
}
